module.exports = __webpack_public_path__ + "static/media/0520-r-en.0db71db5.png";